module.exports = __webpack_public_path__ + "img/IMG_2354.fed0e0e0.jpg";